<div class="wrapper-lg">
    <app-breadcrumbs [items]="[
                     { url: '/bc-contests', text: 'bcContest_listTitle' },
                     { url: '/bc-contests/' + (isNew ? 'add' : item?.Id), text: isNew ? 'bcContest_newTitle' : item?.Name }
                     ]"></app-breadcrumbs>

    <header class="content-header">
        <h1>
            {{(isNew ? 'bcContest_newTitle' : 'bcContest_editTitle') | translate}}
            <app-bc-contest-status [value]="item?.Status" [active]="item?.IsActive"></app-bc-contest-status>
        </h1>
    </header>

    <form #form="ngForm" [class.was-validated]="isSubmitted">
        <div class="row">
            <div class="form-field col-lg-6 col-md-4 required">
                <label class="form-label">{{'bcContest_lblContest' | translate}}</label>
                <app-select [(ngModel)]="contestId"
                            [options]="availableContests"
                            [displayProperty]="'Name'"
                            [valueProperty]="'id'"
                            [required]="true"
                            [disabled]="!isNew"
                            name="contestId">
                </app-select>
            </div>

            <div class="form-field col-lg-3 col-md-4 required">
                <label class="form-label">{{'bcContest_lblStatus' | translate}}</label>
                <app-select [(ngModel)]="status"
                            [options]="availableStatuses"
                            [displayProperty]="'text'"
                            [valueProperty]="'value'"
                            [required]="true"
                            name="status">
                </app-select>
            </div>

            <div class="form-field col-lg-3 col-md-4 required">
                <label class="form-label">{{'bcContest_lblCourseLimit' | translate}}</label>
                <input class="form-control" [(ngModel)]="courseLimit" name="courseLimit" type="number" min="0" step="1" required />
            </div>
        </div>

        <div class="row">
            <div class="col-xl-4 col-md-6 form-field required">
                <label class="form-label">{{'bcContest_lblOpenedFrom' | translate}}</label>
                <div class="datetime">
                    <div>
                        <app-date name="openedFromDate" [(ngModel)]="openedFromDate" [required]="true"
                                  [placeholder]="'bcContest_lblDate' | translate"></app-date>
                    </div>
                    <div>
                        <input class="form-control" [(ngModel)]="openedFromTime" name="openedFromTime" required maxlength="5" [pattern]="timePattern"
                               [placeholder]="'bcContest_lblTime' | translate">
                    </div>
                </div>
            </div>

            <div class="col-xl-4 col-md-6 form-field required">
                <label class="form-label">{{'bcContest_lblOpenedTo' | translate}}</label>
                <div class="datetime">
                    <div>
                        <app-date name="openedToDate" [(ngModel)]="openedToDate" [required]="true"
                                  [placeholder]="'bcContest_lblDate' | translate"></app-date>
                    </div>
                    <div>
                        <input class="form-control" [(ngModel)]="openedToTime" name="openedToTime" required maxlength="5" [pattern]="timePattern"
                               [placeholder]="'bcContest_lblTime' | translate">
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xl-4 col-md-6 form-field required">
                <label class="form-label">{{'bcContest_lblResultsVisibleFrom' | translate}}</label>
                <div class="datetime">
                    <div>
                        <app-date name="visibleFromDate" [(ngModel)]="visibleFromDate" [required]="true"
                                  [placeholder]="'bcContest_lblDate' | translate"></app-date>
                    </div>

                    <div>
                        <input class="form-control" [(ngModel)]="visibleFromTime" name="visibleFromTime" required maxlength="5" [pattern]="timePattern"
                               [placeholder]="'bcContest_lblTime' | translate">
                    </div>
                </div>
            </div>

            <div class="col-xl-4 col-md-6 form-field required">
                <label class="form-label">{{'bcContest_lblResultsVisibleTo' | translate}}</label>
                <div class="datetime">
                    <div>
                        <app-date name="visibleToDate" [(ngModel)]="visibleToDate" [required]="true"
                                  [placeholder]="'bcContest_lblDate' | translate"></app-date>
                    </div>

                    <div>
                        <input class="form-control" [(ngModel)]="visibleToTime" name="visibleToTime" required maxlength="5" [pattern]="timePattern"
                               [placeholder]="'bcContest_lblTime' | translate">
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            
        </div>

        <div class="form-field required">
            <label class="form-label">{{'bcContest_lblDescription' | translate}}</label>
            <editor [(ngModel)]="description" name="description" [init]="editorConfig" #descInput required></editor>
            <div class="invalid-feedback" *ngIf="descInput.errors?.maxlength">
                {{'fieldError_lengthMinMax' | translate | formatString:[0, 4000]}}
            </div>
        </div>

        <div class="form-field required">
            <label class="form-label">{{'bcContest_lblDescriptionEN' | translate}}</label>
            <editor [(ngModel)]="descriptionEN" name="descriptionEN" [init]="editorConfig" #descEnInput="ngModel" required></editor>
            <div class="invalid-feedback" *ngIf="descEnInput.errors?.maxlength">
                {{'fieldError_lengthMinMax' | translate | formatString:[0, 4000]}}
            </div>
        </div>

        <div class="form-actions">
            <button class="btn btn-outline" type="button" [routerLink]="['/bc-contests', item?.Id] | localize">
                {{(isNew ? 'cancel' : 'close') | translate}}
            </button>

            <button class="btn btn-primary" type="button" (click)="save()">
                {{'save' | translate}}
            </button>
        </div>
    </form>
</div>
